export const Footer = () => (
  <footer className="bg-ink text-marigold py-12" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 flex flex-wrap justify-between gap-6 font-mono fr-lbl">
      <span>Families, Reimagined / Coming 2027</span>
      <span>
        <a href="https://www.instagram.com/riseandshiny_/" target="_blank" rel="noopener noreferrer" className="hover:text-rose transition-colors duration-200" data-testid="footer-instagram-link">@riseandshiny_</a>
        {" "}/ Rise &amp; Shiny
      </span>
      <a href="#join" className="hover:text-rose transition-colors duration-200" data-testid="footer-join-link">Join the list</a>
    </div>
  </footer>
);
